import config from '@/assets/config'

// const ww = window.innerWidth
const wh = window.innerHeight

// 场景一
// 旁白
const s1ScrollT = config.scenesScrollT[0]
const s1Talk2D = s1ScrollT * 0.2
const s1Talk2T = s1ScrollT * 0.05
const s1TextD = s1Talk2D + s1Talk2T * 6

// 单车
const s1BikeD = s1ScrollT * 0.1

// 场景二
// 旁白
const s2ScrollD = config.scenesScrollT[0] * (1 - 0.16 / config.ratioP)
const s2ScrollT = config.scenesScrollT[1]

const s2StaticT = 1 * s2ScrollT
const s2StaticW = wh * 2784 / 2436
const s2StaticV = s2StaticW / s2StaticT
const s2StaticD = s2ScrollD + 0 * s2ScrollT

const s2HandL = 810 / 2784
const s2HandScrollW = s2StaticW * (1 - s2HandL)
const s2HandD = s2StaticD + s2HandL * s2StaticT
const s2HandT = s2HandScrollW / s2StaticV
const s2Talk2T = s2ScrollT * 0.05
const s2Talk2D = s2HandD + s2HandT * 0.4
const s2TextD = s2Talk2D + s2Talk2T * 6

// 玩闹的声音
const s2ChildL2 = 2600 / 2784
const s2ChildD2 = s2StaticD + s2ChildL2 * s2StaticT

// 场景三
// 走路
const s3ScrollD = config.scenesScrollD[2]
const s3ScrollT = config.scenesScrollT[2]
const s3BgFadeT = 0.1 * s3ScrollT
const s3BgScrollD = s3ScrollD + s3BgFadeT

// 旁白
const s3BgScrollT = 0.3 * s3ScrollT
const s3TalkD = s3BgScrollD + s3BgScrollT

const s3Talk2D = s3TalkD + s3ScrollT * 0.06
const s3Talk2T = s3ScrollT * 0.03
const s3TextD = s3Talk2D + s3Talk2T * 2

// 场景四
// 人群
const s4ScrollD = config.scenesScrollD[3]
const s4ScrollT = config.scenesScrollT[3]
const s4StaticMoveD = s4ScrollD + s4ScrollT * 0.1
const s4StaticMoveT = s4ScrollT * 0.2
const s4StaticMoveD2 = s4StaticMoveD + s4StaticMoveT

// 旁白
const s4TextD = s4ScrollD + s4ScrollT * 0.95

// 场景五
const s5ScrollD = config.scenesScrollD[4]
const s5ScrollT = config.scenesScrollT[4]
const s5BgMoveT = s5ScrollT * 0.3
const s5Talk1D = s5ScrollD + s5BgMoveT
const s5FadeD = s5Talk1D + s5ScrollT * 0.2
const s5FadeT = s5ScrollT * 0.2
const s5MoneyD = s5FadeD + s5FadeT
const s5MoneyT = s5ScrollT * 0.05
const s5TextD = s5MoneyD + s5MoneyT

// 场景六
// 旁白
const s6ScrollD = config.scenesScrollD[5]
const s6ScrollT = config.scenesScrollT[5]
const s6RotateD = s6ScrollD
const s6RotateT = s6ScrollT * 0.1
const s6MoveD = s6RotateD + s6RotateT
const s6MoveT = s6ScrollT * 0.3
const s6MeFadeD = s6MoveD + s6MoveT
const s6MeFadeT = s6ScrollT * 0.1

const s6Talk1D = s6MeFadeD + s6MeFadeT
const s6Talk1T = s6ScrollT * 0.1
const s6TextD = s6Talk1D + s6Talk1T

// 会议
const s6MeetingD = s6MoveD + s6MoveT * 0.1

// 场景七
const s7ScrollD = config.scenesScrollD[6]
const s7ScrollT = config.scenesScrollT[6]
const s7TextT = s7ScrollT * 0.02
const s7Static2MoveD = s7ScrollD + s7ScrollT * 0.65 // 0.65T
const s7Text1D = s7Static2MoveD + s7ScrollT * 0.03
const s7Text2D = s7Text1D + s7TextT * 4
const s7Text3D = s7Text2D + s7TextT * 4
const s7Text4D = s7Text3D + s7TextT * 4

// 场景八
// 旁白
const s8ScrollD = config.scenesScrollD[7]

export default {
  s1: s1TextD,
  bell: s1BikeD,
  s2: s2TextD,
  children: s2ChildD2,
  walk: s3BgScrollD,
  s3: s3TextD,
  s4: s4TextD,
  crowd: s4StaticMoveD2,
  s5: s5TextD,
  money: s5MoneyD + s5MoneyT / 2,
  s6: s6TextD,
  meeting: s6MeetingD,
  shake: s6MeFadeD - s6MeFadeT * 0.05,
  wechat: s7Text1D + s7TextT * 2,
  message1: s7Text2D + s7TextT * 2,
  message2: s7Text3D + s7TextT * 2,
  message3: s7Text4D + s7TextT * 2,
  s8: s8ScrollD
}



// WEBPACK FOOTER //
// ./src/assets/musicTimes.js